import { Trans } from '@lingui/macro';
import React from 'react';

import { useExpireTimer } from '../hooks';
import { Button } from '@components';

export type SessionExpiryTimerProps = {
    onExtendSession: () => any
    onExpiredCountdown: () => any
    durationSecs: number
};

export function SessionExpiryTimer ({
    onExtendSession, onExpiredCountdown, durationSecs
}: SessionExpiryTimerProps) {
    const expireTimeText = useExpireTimer({
        onExpiredCountdown,
        durationSecs
    });

    return (
        <>
            <h3 data-testid={'session-expiry-timer'}>
                {expireTimeText}
            </h3>

            <Button data-testid={'extend-session-button'} onClick={onExtendSession}>
                <Trans id={'extend'} />
            </Button>
        </>
    );
}
